import React, { Component, createRef } from 'react';
import './style.css'
import Sidebar from './../sidebar'
import Headers from './../headers'
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Axios from 'axios';
import { DB_URL } from '../../helpers/url';
import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import Loading from './../loading'
import Swal from 'sweetalert2'
import {dateToTimeStamp, timestampToDate, dateFormat} from './../../helpers/convertDate'

class Home extends Component {
    state = { 
      isLogin:null,
      data:null,
      modalAdd:false,
      modalProfile:false,
      modalEdit:false,
      subjects:null,
      student_name: createRef(),
      student_parent: createRef(),
      dob: createRef(),
      classroom: createRef(),
      subject: '',
      subject_id:createRef(),
      gender: createRef(),
      userProfile:null,
      editProfile:null,
      classrooms:null,
      page:1,
      totalRow:0,
      isEditBio:false,
      height:createRef(),
      weight:createRef(),
      bust:createRef(),
      waist:createRef(),
      hips:createRef(),
      shirt:createRef(),
      pants:createRef(),
      shoe:createRef(),
      filesPreview:null,
      files:null,
      csvPath: null
    }

    toggle=(type)=>{
      if(type===1){
        this.setState({modalAdd:!this.state.modalAdd})
      }
      if(type===2){
        this.setState({modalProfile:!this.state.modalProfile,isEditBio:false})
        if(!this.state.modalProfile) this.setState({userProfile:null})
      }
      if(type===3){
        this.setState({modalEdit:!this.state.modalEdit})
        if(!this.state.modalEdit) this.setState({editProfile:null})
      }
    }

    getClassroom=(e)=>{
      this.setState({subject:e.target.value})
    }

    componentDidMount(){
      this.fetchTotalRow()
      this.fetchDataStudent(this.state.page)
      this.fetchDataSubject()
      this.fetchDataClass()
    }

    fetchTotalRow=()=>{
      Axios.get(`${DB_URL}/student/gettotalrow`)
      .then((res)=>{
        this.setState({totalRow:res.data[0].total_row})
      }).catch((err)=>console.log(err))
    }

    fetchDataStudent=(page)=>{
      Axios.get(`${DB_URL}/student/getallstudent?page=${page}`)
      .then((res)=>{
        this.setState({data:res.data})
      }).catch((err)=>console.log(err))
    }

    fetchDataStudentById=(student_id)=>{
      Axios.get(`${DB_URL}/student/getallstudent/${student_id}`)
      .then((res)=>{
        console.log(res.data)
        res.data?  this.setState({userProfile:res.data}) : this.setState({userProfile:null})  
      }).catch((err)=>console.log(err))
    }

    fetchDataStudentByIdEdit=(student_id)=>{
      Axios.get(`${DB_URL}/student/getallstudent/${student_id}`)
      .then((res)=>{
        console.log(res.data)
        res.data?  this.setState({editProfile:res.data}) : this.setState({editProfile:null})  
      }).catch((err)=>console.log(err))
    }

    fetchDataSubject=()=>{
      Axios.get(`${DB_URL}/subject/getsubject`)
      .then((res)=>{
        this.setState({subjects:res.data})
      }).catch((err)=>console.log(err))
    }

    fetchDataClass=()=>{
      Axios.get(`${DB_URL}/subject/getclass`)
      .then((res)=>{
        this.setState({classrooms:res.data})
      }).catch((err)=>console.log(err))
    }
    
    renderTable=()=>{
      return this.state.data.map((value,index)=>{
        return (
          <tr key={value.student_id} className='text-pink'>
            <th>{index+1+((this.state.page-1)*5)}</th>
            <td>{value.student_name}</td>
            <td>{value.student_parent}</td>
            <td>{timestampToDate(value.bod)}</td>
            <td>{value.class_name + ' ' + value.subject_name}</td>
            <td>
              <button className='btn btn-primary mr-2' onClick={()=>this.renderProfile(value.student_id)}>Profile</button>
              <button className='btn-edit-cust mr-2' onClick={()=>this.renderEdit(value.student_id)}>Edit</button>
              <button className='btn-delete-cust' onClick={()=>this.deleteStudent(value.student_id,value.student_name)}>Delete</button>
            </td>
          </tr>
        )
      })
    }

    renderProfile=(student_id)=>{
      this.toggle(2)
      this.fetchDataStudentById(student_id)
    }

    renderEdit=(student_id)=>{
      this.toggle(3)
      this.fetchDataStudentByIdEdit(student_id)
    }

    changePage=(inp)=>{
      Axios.get(`${DB_URL}/student/getallstudent?page=${inp}`)
      .then((res)=>{
        this.setState({data:res.data})
        this.setState({page:inp})
      }).catch((err)=>console.log(err))
    }

    renderPaging=()=>{
      let rowPerPage = Math.ceil(this.state.totalRow/5)
      let arr = new Array(rowPerPage)
      for(let i=0;i<arr.length;i++){
        if((i+1) === this.state.page){
          arr[i]=(<PaginationItem  key={i} disabled>
                    <PaginationLink >
                      {i+1}
                    </PaginationLink>
                  </PaginationItem>)
        }else{
          arr[i]=(<PaginationItem  key={i} onClick={()=>this.changePage(i+1)} >
                    <PaginationLink >
                      {i+1}
                    </PaginationLink>
                  </PaginationItem>)
        }
      }
      return arr
    }

    deleteStudent=(id, student_name)=>{
      Swal.fire({
        title: `Are you sure deleting ${student_name}?`,
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          Axios.delete(`${DB_URL}/student/deletestudent/${id}`)
          .then(()=>{
            Swal.fire(
              'Deleted!',
              'Your just deleted the data.',
              'success'
            )
            let lastRow = this.state.totalRow
            this.fetchTotalRow()
            this.setState({csvPath:null})
            if(lastRow<this.state.totalRow) this.fetchDataStudent(this.state.page-1)
            else{
              this.fetchDataStudent(this.state.page)
              this.renderTable()
            }
          }).catch((err)=>console.log(err))
        }
      })
    }

    insertStudent=()=>{
      let {student_name,student_parent,classroom,dob,subject,gender} = this.state
      if(!student_name.current.value || !classroom.current.value || !subject || !gender.current.value || !dob.current.value){
        Swal.fire({
          icon: 'error',
          title: 'Please fill all the field',
          showConfirmButton: true
        })
      } else {
        let unix_time = dateToTimeStamp(dob.current.value)
        let data = {
          student_name:student_name.current.value,
          student_parent:student_parent.current.value,
          subject_id:subject,
          bod:unix_time,
          classroom_id:classroom.current.value,
          updated_by: this.props.username,
          gender:gender.current.value
        }
        console.log(data)
        Axios.post(`${DB_URL}/student/insertstudent`,data)
        .then(()=>{
          Swal.fire({
            icon: 'success',
            title: 'Student has been added',
            showConfirmButton: false,
            timer: 1200
          })
          this.toggle(1)
          this.setState({csvPath:null})
          this.componentDidMount()
        }).catch((err)=>console.log(err))
      }
    }

    editStudent=(student_id)=>{
      const {student_name,student_parent,classroom,dob,subject_id,gender} = this.state
      let unix_time = dateToTimeStamp(dob.current.value)
      let data = {
        student_name:student_name.current.value,
        student_parent:student_parent.current.value,
        subject_id:subject_id.current.value,
        bod:unix_time,
        classroom_id:classroom.current.value,
        updated_by: this.props.username,
        gender:gender.current.value
      }
      console.log(data)
      Axios.put(`${DB_URL}/student/editstudentbyid/${student_id}`,data)
      .then(()=>{
        Swal.fire({
          icon: 'success',
          title: 'Student has been edited',
          showConfirmButton: false,
          timer: 1200
        })
        this.toggle(3)
        this.fetchDataStudent(this.state.page)
        this.setState({csvPath:null})
      }).catch=((err)=>console.log(err))
    }

    editBio=(student_id)=>{
      //upload bio
      const {height,weight,bust,waist,hips,shirt,pants,shoe} = this.state
      if(!height.current.value) height.current.value  = 0
      if(!weight.current.value) weight.current.value  = 0
      if(!bust.current.value) bust.current.value  = 0
      if(!waist.current.value) waist.current.value  = 0
      if(!hips.current.value) hips.current.value  = 0
      if(!shirt.current.value) shirt.current.value  = 0
      if(!pants.current.value) pants.current.value  = 0
      if(!shoe.current.value) shoe.current.value  = 0
      let data = {
        height:height.current.value,
        weight:weight.current.value,
        bust:bust.current.value,
        waist:waist.current.value,
        hips:hips.current.value,
        shirt:shirt.current.value,
        pants:pants.current.value,
        shoe:shoe.current.value
      }
      console.log(data)
      Axios.put(`${DB_URL}/student/editstudentbyid/${student_id}`,data)
      .then(()=>{
        this.uploadPhoto(student_id)
        Axios.get(`${DB_URL}/student/getallstudent/${student_id}`)
        .then((res)=>{
          res.data?  this.setState({userProfile:res.data}) : this.setState({userProfile:null})  
          Swal.fire({
            icon: 'success',
            title: 'Student has been edited',
            showConfirmButton: false,
            timer: 1200
          })
          this.toggle(2)
          this.setState({csvPath:null})
        }).catch((err)=>console.log(err))
      }).catch=((err)=>console.log(err))
    }

    uploadPhoto=(student_id)=>{
      if(this.state.files){
        let formData=new FormData()
        let option={
          headers:{
              'content-type':'multipart/form-data'
          }
        }
        let data_img={
            student_id
        }
        formData.append('image',this.state.files)
        formData.append('data',JSON.stringify(data_img))
        Axios.post(`${DB_URL}/photo/editprofilephoto/${student_id}`,formData,option)
        .then((res)=>{
          this.setState({files:null})
        }).catch((err)=>console.log(err))
      }
    }

    toggleEdit=()=>{
      this.setState({isEditBio:!this.state.isEditBio, file:null})
    }

    renderSubject=()=>{
      return this.state.subjects.map((val,index)=>{
        return (
          <>
            <option value={val.subject_id}>{val.subject_name}</option>
          </>
        )
      })
    }

    renderSubjectOnEdit=(subject_id)=>{
      console.log(this.state.editProfile)
      let arr = this.state.subjects.filter((val)=>{
        return subject_id !== val.subject_id
      })
      return arr.map((val)=>{
        return (
          <>
            <option value={val.subject_id}>{val.subject_name}</option>
          </>
        )
      })
    }

    renderClass=()=>{
      let arrClass = this.state.classrooms.filter((val)=>{
        return val.subject_id === parseInt(this.state.subject)
      })
      return arrClass.map((val,index)=>{
        return (
          <>
            <option value={val.classroom_id}>{val.class_name}</option>
          </>
        )
      })
    }

    renderClassEdit=()=>{
      let arrClass = this.state.classrooms.filter((val)=>{
        return val.subject_id === parseInt(this.state.subject)
      })
      return arrClass.map((val,index)=>{
        return (
          <>
            <option value={val.classroom_id}>{val.class_name}</option>
          </>
        )
      })
    }

    handleChange=(event)=>{
      if(event.target.files[0]){
        this.setState({
          filesPreview: URL.createObjectURL(event.target.files[0]),
          files:event.target.files[0]
        })
      }else{
          this.setState({files:null,filesPreview:null})
      }
    }

    downloadToCsv=()=>{
      Axios.post(`${DB_URL}/print/downloadcsv`)
      .then((res)=>{
        this.setState({csvPath:res.data})
      }).catch((err)=>console.log(err))
    }

    render() { 
      if(this.state.data===null || this.state.subjects===null || this.state.classrooms===null || this.state.totalRow===null){
        return(
          <>
            <Loading/>
          </>
        )
      }
      return (
        <>
        {
          this.props.username?
          <div className='row m-0 p-0 bg-clr'>
            <div className='col-2'>
              <Sidebar/>
            </div>
            <div className='col-10 bg-table'>
              <Headers className='bg-12'/>
              <div className='col-12 bg-white-table d-flex'>
                <div className='my-3'>
                  <button className='btn btn-outline-primary mx-2' onClick={()=>this.toggle(1)}>Insert Student</button>
                  {
                    this.state.csvPath?
                    <a className='btn btn-primary mr-2' href={DB_URL+'/'+this.state.csvPath+'.csv'} download>Download</a>
                    :
                    <button className='btn btn-primary mr-2' onClick={this.downloadToCsv}>Print to CSV</button>
                  }
                  <button className='btn btn-primary'>Upload</button>
                </div>
              </div>
              <div className=' col-12 bg-white-table'>
                <Table responsive hover borderless>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Student Name</th>
                      <th>Parent Name</th>
                      <th>Bith of Date</th>
                      <th>Class</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderTable()}
                  </tbody>
                </Table>
                <Pagination aria-label="Page navigation example" className='d-flex align-items-center justify-content-center'>
                  {this.renderPaging()}
                </Pagination>
              </div>
            </div>
            <Modal isOpen={this.state.modalAdd} toggle={()=>this.toggle(1)}>
              <ModalHeader toggle={()=>this.toggle(1)}>Insert Data of Student</ModalHeader>
              <ModalBody>
                <form>
                  <input ref={this.state.student_name} type='text' className='form-control mb-2' placeholder='Student Name' required/>
                  <select ref={this.state.gender} class="form-control mb-2" id="exampleFormControlSelect1">
                    <option value='' hidden>select gender</option>
                    <option value='1'>Boy</option>
                    <option value='0'>Girl</option>
                  </select>              
                  <input ref={this.state.student_parent} type='text' className='form-control mb-2' placeholder='Parent Name'/>
                  <input ref={this.state.dob} type='date' className='form-control mb-2' placeholder='Birth of Date'/>
                  <select value={this.state.subject} onChange={this.getClassroom} class="form-control mb-2" id="exampleFormControlSelect1">
                    <option value='' hidden>select subject</option>
                    {this.renderSubject()}
                  </select>
                  <select ref={this.state.classroom} class="form-control" id="exampleFormControlSelect1">
                    {
                      this.state.subject===null?
                      <option value='' disabled>select subject first</option>
                      :
                      <>
                        <option value='' hidden>select class</option>
                        {this.renderClass()}
                      </>
                    }
                  </select>   
                </form>
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={this.insertStudent}>Add</Button>{' '}
                <Button color="secondary" onClick={()=>this.toggle(1)}>Cancel</Button>
              </ModalFooter>
            </Modal>
            <Modal isOpen={this.state.modalProfile} toggle={()=>this.toggle(2)} size='lg'>
              <ModalHeader toggle={()=>this.toggle(2)}>Profile Data of Student</ModalHeader>
              {
                this.state.isEditBio?
                <>
                  <ModalBody className='row'>
                    {
                      this.state.userProfile===null?
                      <div>Loading...</div>
                      :
                      <>
                        <div className='col-4'>
                          {
                            this.state.filesPreview === null?
                            <img alt="" src={DB_URL+this.state.userProfile.profile_pict} width='250vw' height='250vw' className='img-student'/>
                            :
                            <img alt="" src={this.state.filesPreview} width='250vw' height='250vw' className='img-student'/>
                          }
                          <input type="file" onChange={this.handleChange} className='my-2'/>
                        </div>
                        <div className='col-8'>
                          <div class="row mb-2">
                            <div class="col">
                              <label>Height</label>
                              <input type="number" class="form-control" defaultValue={this.state.userProfile.height} ref={this.state.height}/>
                            </div>
                            <div class="col">
                              <label>Weight</label>
                              <input type="number" class="form-control" defaultValue={this.state.userProfile.weight} ref={this.state.weight}/>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col">
                              <label>Bust</label>
                              <input type="number" class="form-control" defaultValue={this.state.userProfile.bust} ref={this.state.bust}/>
                            </div>
                            <div class="col">
                              <label>Waist</label>
                              <input type="number" class="form-control" defaultValue={this.state.userProfile.waist} ref={this.state.waist}/>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col">
                              <label>Hips</label>
                              <input type="number" class="form-control" defaultValue={this.state.userProfile.hips} ref={this.state.hips}/>
                            </div>
                            <div class="col">
                              <label>Shirt</label>
                              <input type="text" class="form-control" defaultValue={this.state.userProfile.shirt} ref={this.state.shirt}/>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col">
                              <label>Pants</label>
                              <input type="text" class="form-control" defaultValue={this.state.userProfile.pants} ref={this.state.pants}/>
                            </div>
                            <div class="col">
                              <label>Shoe</label>
                              <input type="number" class="form-control" defaultValue={this.state.userProfile.shoe} ref={this.state.shoe}/>
                            </div>
                          </div>
                        </div>
                      </>
                    }
                  </ModalBody>
                  <ModalFooter>
                    <Button color="success" onClick={()=>this.editBio(this.state.userProfile.student_id)}>Save</Button>{' '}
                    <Button color="danger" onClick={this.toggleEdit}>Cancel</Button>
                  </ModalFooter>
                </>
                :
                <>
                  <ModalBody className='row'>
                    {
                      this.state.userProfile===null?
                      <div>Loading...</div>
                      :
                      <>
                        <div className='col-4'>
                          <img alt="" src={DB_URL+this.state.userProfile.profile_pict} width='250vw' height='250vw' className='img-student'/>
                          <h4 style={{textTransform:'capitalize'}} className='text-center'>{this.state.userProfile.student_name}</h4>
                        </div>
                        <div className='col-8'>
                          <div class="row mb-2">
                            <div class="col">
                              <label>Height</label>
                              <input type="number" class="form-control" value={this.state.userProfile.height} readOnly/>
                            </div>
                            <div class="col">
                              <label>Weight</label>
                              <input type="number" class="form-control" value={this.state.userProfile.weight} readOnly/>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col">
                              <label>Bust</label>
                              <input type="number" class="form-control" value={this.state.userProfile.bust} readOnly/>
                            </div>
                            <div class="col">
                              <label>Waist</label>
                              <input type="number" class="form-control" value={this.state.userProfile.waist} readOnly/>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col">
                              <label>Hips</label>
                              <input type="number" class="form-control" value={this.state.userProfile.hips} readOnly/>
                            </div>
                            <div class="col">
                              <label>Shirt</label>
                              <input type="text" class="form-control" value={this.state.userProfile.shirt} readOnly/>
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col">
                              <label>Pants</label>
                              <input type="text" class="form-control" value={this.state.userProfile.pants} readOnly/>
                            </div>
                            <div class="col">
                              <label>Shoe</label>
                              <input type="number" class="form-control" value={this.state.userProfile.shoe} readOnly/>
                            </div>
                          </div>
                        </div>
                      </>
                    }
                  </ModalBody>
                  <ModalFooter>
                    <Button color="primary" onClick={this.toggleEdit}>Edit</Button>{' '}
                    <Button color="secondary" onClick={()=>this.toggle(2)}>Cancel</Button>
                  </ModalFooter>
                </>
              }
            </Modal>
            <Modal isOpen={this.state.modalEdit} toggle={()=>this.toggle(3)}>
              <ModalHeader toggle={()=>this.toggle(3)}>Edit Data</ModalHeader>
              <ModalBody>
                {
                  this.state.editProfile === null?
                  <div>Loading...</div>
                  :
                  <>
                    <input ref={this.state.student_name} type='text' className='form-control mb-2' defaultValue={this.state.editProfile.student_name}/>
                    <select ref={this.state.gender} class="form-control mb-2" id="exampleFormControlSelect1">
                      {
                        this.state.editProfile.gender?
                        <>
                          <option value='1' selected>Boy</option>
                          <option value='0'>Girl</option>
                        </>
                        :
                        <>
                          <option value='0' selected>Girl</option>
                          <option value='1'>Boy</option>
                        </>
                      }
                    </select>              
                    <input ref={this.state.student_parent} type='text' className='form-control mb-2' defaultValue={this.state.editProfile.student_parent}/>
                    <input ref={this.state.dob} type='date' className='form-control mb-2' defaultValue={dateFormat(this.state.editProfile.bod)}/>
                    <select ref={this.state.subject_id} defaultValue={this.state.editProfile.subject_id} onChange={this.getClassroom} class="form-control mb-2" id="exampleFormControlSelect1">
                      {this.renderSubject(this.state.editProfile.subject_id)}
                    </select>
                    <select defaultValue={this.state.editProfile.classroom_id} ref={this.state.classroom} class="form-control" id="exampleFormControlSelect1">
                      <option value={this.state.editProfile.classroom_id} disabled>{this.state.editProfile.class_name}</option>
                      {this.renderClassEdit()}
                    </select> 
                  </>            
                }
              </ModalBody>
              <ModalFooter>
                <Button color="primary" onClick={()=>this.editStudent(this.state.editProfile.student_id)}>Edit</Button>{' '}
                <Button color="secondary" onClick={()=>this.toggle(3)}>Cancel</Button>
              </ModalFooter>
            </Modal>
          </div>
          :
          <Redirect exact to='/login'/>
        }
        </>
      );
    }
}

const reduxProps=({Auth})=>{
  return{
    ...Auth
  }
}
 
export default connect(reduxProps)(Home);